import React, { useState } from "react";
import { ResponsiveImage } from "@quintype/components";
import { object } from "prop-types";

import LightBox from "../../../../molecules/LightBox";
import ScrollSnap from "../../../../molecules/ScrollSnap";
import { SvgIconHandler } from "../../../../atoms/svg-icon-hadler";

import "./gallery-element.m.css";

const ImageGalleryElement = ({ element, story }) => {
  if (element["story-elements"].length < 1) {
    return null;
  }

  const [isLightbox, setIsLightbox] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(null);

  const onClickHandler = (index) => {
    setIsLightbox(true);
    setCarouselIndex(index);
  };

  const images = element["story-elements"].slice(0, 6).map((image, index) => (
    <div styleName="image-wrapper" onClick={() => onClickHandler && onClickHandler(index)} key={index}>
      {element["story-elements"].length > 6 && index === 5 && (
        <div styleName="more-images">
          <span styleName="more-number">+{element["story-elements"].length - 6}</span>
        </div>
      )}
      <figure data-test-id="story-element-image-container" key={image.id} styleName="qt-image-1x1">
        <ResponsiveImage
          slug={image["image-s3-key"]}
          metadata={image.metadata}
          aspectRatio={[1, 1]}
          imgParams={{ auto: ["format", "compress"] }}
          alt={image.title || story.headline}
        />
      </figure>
    </div>
  ));

  const children = element["story-elements"].map((item, index) => <LightBox element={item} key={index} />);

  return (
    <div styleName="wrapper" className="story-element-image-gallery" data-test-id="story-element-image-gallery">
      {images}
      {isLightbox && (
        <div styleName="carousel-wrapper">
          <div styleName="close-wrapper" onClick={() => setIsLightbox(false)}>
            <SvgIconHandler type="white-close" width="18" height="18" viewBox="0 0 18 18" />
          </div>
          <ScrollSnap
            leftArrow={
              <SvgIconHandler
                iconStyle={{ color: "#fff" }}
                type="rightarrow"
                width="10"
                height="18"
                viewBox="0 0 10 18"
              />
            }
            rightArrow={
              <SvgIconHandler
                iconStyle={{ color: "#fff" }}
                type="rightarrow"
                width="10"
                height="18"
                viewBox="0 0 10 18"
              />
            }
            defaultSelection={carouselIndex}
          >
            {children}
          </ScrollSnap>
        </div>
      )}
    </div>
  );
};

ImageGalleryElement.propTypes = {
  element: object,
  story: object,
};

export default ImageGalleryElement;
